import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLiechtenstein = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_29_1149)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M24 12C24 18.6274 18.6274 24 12 24C5.37262 24 0 18.6274 0 12C0.521719 12 12 10.4348 12 10.4348L24 12Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0 12C0 5.37262 5.37262 0 12 0C18.6274 0 24 5.37262 24 12",
				fill: "#0052B4"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8.8695 8.34784C8.8695 7.48341 8.16872 6.78263 7.30429 6.78263C6.90328 6.78263 6.5378 6.93357 6.26081 7.18149V6.26087H6.78253V5.21738H6.26081V4.69566H5.21733V5.21738H4.69561V6.26087H5.21733V7.18149C4.94034 6.93357 4.57486 6.78263 4.17384 6.78263C3.30942 6.78263 2.60864 7.48341 2.60864 8.34784C2.60864 8.81129 2.81025 9.22754 3.13036 9.51418V10.4348H8.34773V9.51418C8.66793 9.22754 8.8695 8.81129 8.8695 8.34784Z",
				fill: "#FFDA44"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_29_1149",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgLiechtenstein;
